import { createFileRoute } from "@tanstack/react-router";
import { NoChatSelected } from "@/features/chat/components/NoChatSelected";

export const Route = createFileRoute("/chat-room/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <NoChatSelected />;
}
